export const STRAPI_API_URL = process.env.STRAPI_API_URL;
export const STRAPI_AUTH_KEY = process.env.STRAPI_AUTH_KEY;
export const STRAPI_CONTENT_URL = process.env.NEXT_PUBLIC_STRAPI_CONTENT_URL;
export const STRAPI_LANDING_PAGE_CACHE_KEY = 'strapiLandingPage-';
